// useOptions.js
import { useState, useEffect } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const useOptions = () => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/users/list`);
        const { locations, roles } = response.data;
        setLocationOptions(
          locations
            .sort((a, b) => a.id - b.id) // Sort by id before mapping
            .map((location) => ({
              label: location.location_name,
              id: location.id,
            }))
        );
        setRoleOptions(
          roles.map((role) => ({ label: role.role_name, id: role.id }))
        );
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };

    fetchOptions();
  }, []);

  // console.log("roleOptions (useOptions.js)", roleOptions);
  return { locationOptions, roleOptions };
};

export default useOptions;
